import { Link } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';

const breadcrumb = [
  { label: 'Accueil', to: '/' },
  { label: 'Blog' },
];

const articles = [
  {
    slug: 'changer-roulettes-baie-coulissante',
    title: 'Changer les roulettes d&apos;une baie coulissante : guide complet',
    excerpt: 'Votre baie coulissante est devenue dure à manœuvrer ? Les roulettes sont probablement usées. Découvrez quand et comment les changer, les signes qui ne trompent pas, et pourquoi confier cette opération à un professionnel dans l&apos;Hérault.',
    date: '15 juillet 2026',
    imageAlt: 'Roulettes de baie coulissante usées à remplacer',
  },
  {
    slug: 'baie-coulissante-qui-coince-que-faire',
    title: 'Baie coulissante qui coince : causes et solutions',
    excerpt: 'Une baie vitrée dure à ouvrir ou fermer peut avoir plusieurs origines : roulettes encrassées, rail déformé, désalignement du vantail. Voici ce que vous pouvez vérifier vous-même et quand faire appel à un réparateur dans l&apos;Hérault.',
    date: '20 juin 2026',
    imageAlt: 'Baie coulissante qui coince, diagnostic',
  },
  {
    slug: 'baie-vitree-deraille-sort-du-rail',
    title: 'Baie vitrée qui déraille ou sort du rail : que faire',
    excerpt: 'Quand une baie coulissante sort de son rail, la situation peut être inquiétante. Découvrez les causes fréquentes de déraillement, comment remettre le vantail en sécurité et l&apos;importance d&apos;un entretien adapté, surtout en zone littorale comme l&apos;Hérault.',
    date: '5 juin 2026',
    imageAlt: 'Baie vitrée déraillée sortie du rail',
  },
  {
    slug: 'prix-reparation-roulettes-baie-vitree',
    title: 'Combien coûte le changement des roulettes d&apos;une baie vitrée',
    excerpt: 'Le prix d&apos;un changement de roulettes de baie coulissante dépend de plusieurs facteurs : nombre de vantaux, type de galets, accessibilité. On fait le point sur ce qui influence le tarif, sans chiffres inventés.',
    date: '28 mai 2026',
    imageAlt: 'Devis réparation roulettes baie vitrée',
  },
  {
    slug: 'volet-roulant-ne-remonte-plus',
    title: 'Volet roulant qui ne remonte plus : causes et solutions',
    excerpt: 'Votre volet roulant est bloqué en position basse et refuse de remonter ? Qu&apos;il soit électrique ou manuel, les causes peuvent être multiples. On vous explique comment diagnostiquer la panne avant de faire appel à un pro dans l&apos;Hérault.',
    date: '12 avril 2026',
    imageAlt: 'Volet roulant bloqué ne remonte plus',
  },
  {
    slug: 'volet-roulant-electrique-en-panne',
    title: 'Volet roulant électrique en panne : diagnostic complet',
    excerpt: 'Votre volet roulant électrique ne réagit plus, bourdonne sans bouger ou s&apos;arrête en cours de course ? Apprenez à identifier les symptômes pour mieux expliquer la panne à votre réparateur dans l&apos;Hérault.',
    date: '30 mars 2026',
    imageAlt: 'Diagnostic panne volet roulant électrique',
  },
  {
    slug: 'double-vitrage-embue',
    title: 'Double vitrage embué dans l&apos;Hérault : causes et solutions',
    excerpt: 'De la buée entre les deux vitres de votre fenêtre ou baie ? C&apos;est le signe que le joint périphérique du double vitrage est endommagé. Voici pourquoi cela arrive et comment y remédier efficacement.',
    date: '18 mars 2026',
    imageAlt: 'Double vitrage embué avec buée entre les vitres',
  },
  {
    slug: 'store-banne-bloque-que-faire',
    title: 'Store banne bloqué dans l&apos;Hérault : causes et dépannage',
    excerpt: 'Votre store banne ne veut plus se déployer ou refuse de se rétracter ? Moteur, télécommande, bras articulés : on passe en revue les causes possibles et les gestes à éviter pour ne pas aggraver la panne.',
    date: '2 mars 2026',
    imageAlt: 'Store banne bloqué en position déployée',
  },
];

const jsonLdBlog = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'Blog DFPRO Hérault',
  description: 'Conseils et guides pratiques pour réparer baie coulissante, volet roulant, vitrage et store dans l\'Hérault.',
  url: 'https://heraultroulettesbaiesvitrees.fr/blog/',
  publisher: {
    '@type': 'Organization',
    '@id': 'https://heraultroulettesbaiesvitrees.fr/#business',
    name: 'DFPRO Hérault',
  },
  blogPost: articles.map((article, index) => ({
    '@type': 'BlogPosting',
    headline: article.title.replace(/&apos;/g, '\''),
    url: `https://heraultroulettesbaiesvitrees.fr/blog/${article.slug}/`,
    datePublished: `2026-${String(3 + index).padStart(2, '0')}-01`,
    author: { '@type': 'Organization', name: 'DFPRO Hérault' },
  })),
};

export default function BlogIndex() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdBlog)}</script>
      <SEO
        title="Blog DFPRO Hérault | Baie coulissante, volet, vitrage"
        description="Conseils et guides pratiques pour réparer baie coulissante, volet roulant, vitrage et store dans l'Hérault. Entretenez vos menuiseries avec les experts DFPRO."
        canonicalUrl="https://heraultroulettesbaiesvitrees.fr/blog/"
      />

      {/* Hero */}
      <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden">
        <img
          src="/images/blog-index-hero.jpg"
          alt="Blog DFPRO Hérault - conseils et guides"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/75"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumb} light />
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mt-4 mb-3 leading-tight">
            Conseils et guides — DFPRO Hérault
          </h1>
          <p className="text-white/85 text-base md:text-lg font-body max-w-2xl leading-relaxed">
            Retrouvez nos articles pratiques pour comprendre, entretenir et dépanner vos menuiseries : baies coulissantes, volets roulants, vitrages et stores.
          </p>
        </div>
      </section>

      {/* Articles grid */}
      <section className="py-12 md:py-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}/`}
                className="group block bg-white rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-accent-500/30"
              >
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-2 text-secondary-500 text-xs font-body mb-3">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-calendar-line text-xs"></i>
                    </span>
                    <span>{article.date}</span>
                  </div>
                  <h2 className="text-base md:text-lg font-heading font-bold text-primary-500 mb-2 group-hover:text-accent-500 transition-colors duration-200 leading-snug">
                    {article.title}
                  </h2>
                  <p className="text-sm text-foreground-500 font-body leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center gap-1 text-accent-500 text-sm font-label font-semibold">
                    Lire l&apos;article
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-background-100 py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-lg md:text-xl font-heading font-bold text-primary-500 mb-3">
            Besoin d&apos;un dépannage dans l&apos;Hérault ?
          </h2>
          <p className="text-secondary-500 font-body text-sm md:text-base mb-6 max-w-lg mx-auto">
            Nos techniciens interviennent sous 24 à 48h, 7j/7, pour tous vos problèmes de menuiseries. Devis gratuit et sans engagement.
          </p>
          <a href="tel:+33980802242" className="btn-call text-sm px-6 py-3 whitespace-nowrap inline-flex">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm"></i>
            </span>
            09 80 80 22 42
          </a>
        </div>
      </section>
    </>
  );
}